module.exports = __webpack_public_path__ + "img/company-attest.c4811635.svg";